import { motion } from "framer-motion";
import { CheckCircle2, ExternalLink, Vote } from "lucide-react";
import { Reveal } from "./Reveal";

const VOTER_URL = "https://www.winnipeg.ca/city-governance/wards-elections/2026-election/voter-app";

export const VoterCheck = () => {
  return (
    <section id="vote" className="py-20 lg:py-28 bg-slate-50 border-y border-slate-100" data-testid="voter-check-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] bg-slate-900 px-7 py-12 sm:px-14 sm:py-16">
            <div className="pointer-events-none absolute -top-16 -right-10 h-64 w-64 rounded-full bg-teal-500/20 blur-3xl" />
            <div className="relative grid lg:grid-cols-12 gap-10 items-center">
              <div className="lg:col-span-8">
                <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold tracking-[0.18em] text-teal-300 uppercase">
                  <Vote size={15} /> Make Your Voice Count
                </div>
                <h2 className="font-display font-extrabold tracking-tight text-white text-3xl md:text-4xl lg:text-5xl mt-5 leading-tight">
                  Are you registered to vote?
                </h2>
                <p className="mt-5 text-lg text-slate-300 leading-relaxed max-w-xl">
                  Check if you're on the City of Winnipeg voters list — or add your name — in just
                  a couple of minutes. Every voice in Pembina Trails matters.
                </p>
                <ul className="mt-6 space-y-2.5">
                  {["Confirm your registration status", "Register if you're not on the list", "Find the ward where you vote"].map((t) => (
                    <li key={t} className="flex items-center gap-3 text-slate-200">
                      <CheckCircle2 size={18} className="text-teal-400 shrink-0" /> {t}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="lg:col-span-4 lg:text-right">
                <motion.a
                  href={VOTER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileTap={{ scale: 0.98 }}
                  className="group inline-flex items-center justify-center gap-2 rounded-full bg-teal-500 text-white font-semibold px-7 py-4 hover:bg-teal-400 transition-colors"
                  data-testid="voter-check-button"
                >
                  Check or Register to Vote
                  <ExternalLink size={18} className="transition-transform group-hover:translate-x-0.5" />
                </motion.a>
                <p className="mt-4 text-sm text-slate-400">
                  Opens the official City of Winnipeg voter portal.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
